// ============= Imports =============
import { AuthContextProps } from '@/contexts/AuthContext';
import { tokenManager } from '@tw/tw-component-library';
import { AskPersona } from '../types';

// ============= Constants =============
const ASK_BASE_URL = import.meta.env.VITE_BASE_ASK_URL;
const ASK_API_ENDPOINT = '/api/AskPersona';
const ASK_LITIUM_SCOPE =
  'api://c98b7623-f120-463e-9a81-42e287c0ab58/access_as_user';

const HEADERS = {};

// ============= Types =============

export interface GetAskPersonasProps {
  getAccessToken: AuthContextProps['getAccessToken'];
}

// ============= Utility Functions =============
/**
 * Creates headers for API request
 * @param token Authentication token
 * @returns Headers object
 */
const createHeaders = (token: string) => ({
  Authorization: `Bearer ${token}`,
  ...HEADERS,
});

// ============= Main Function =============
/**
 * Load all AskPersonas
 * @param getAccessToken Function to acquire access token
 * @returns Promise with API response containing list of Ask Personas or error
 */
export const getAskPersonas = async ({
  getAccessToken,
}: GetAskPersonasProps): Promise<AskPersona[]> => {
  try {
    console.log('🔄 Fetching Ask Personas...');

    // Token acquisition with required scopes
    const token = await getAccessToken([ASK_LITIUM_SCOPE]);
    if (!token) {
      throw new Error('Failed to acquire API token');
    }
    tokenManager.logTokenInfo(token, 'API');

    // URL construction
    const url = `${ASK_BASE_URL}${ASK_API_ENDPOINT}`;
    const convertURI = encodeURI(url);
    console.log('🌐 Making request to:', convertURI);

    // API request
    const response = await fetch(convertURI, {
      method: 'GET',
      headers: createHeaders(token),
    });

    // Response handling
    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Ask Personas fetched successfully');

    return data;
  } catch (error) {
    console.error('🔴 Error fetching Ask Personas:', error);
    throw error;
  }
};
